var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzBaseButton,{class:[
    'relative',
    'flex',
    'items-center',
    'text-dark-text-100',
    'dark:text-light-text-100',
    'py-3 @tablet-portrait/surface-container:py-2 tablet-portrait:-@:py-2',
    'ps-3 pe-0',

    // Background
    'dark:bg-dark-ui-200',
    _vm.color === 'green' && ['bg-park-0'],
    _vm.color === 'orange' && ['bg-tangerine-0'],
    _vm.color === 'pink' && ['bg-padlet-pink-0'],
    _vm.color === 'blue' && ['bg-oceanic-0'],
    _vm.color === 'purple' && ['bg-grape-0'],
    _vm.color === 'teal' && ['bg-teal-0'],

    // Interaction
    !_vm.disabled && [
      'transition-all',

      // Animation
      'hhover:animate-pulse-bg-color',
      'hactive:animate-none',
      'hfocus-visible:animate-none',
      'dark:pulse-bg-from-dark-ui-200',
      'dark:pulse-bg-to-dark-ui-300',

      // Hover/Focus/Active
      'hactive:text-dark-text-100',
      'hactive:dark:bg-dark-ui-300',
      'hactive:dark:text-light-text-100',
      'hfocus-visible:dark:bg-dark-ui-300',
      'dark:active:bg-dark-ui-300',
      'dark:active:text-light-text-100',
      'dark:focus-visible:bg-dark-ui-300',
      'active:text-dark-text-100',

      // Focus ring
      '@tablet-portrait/surface-container:focus-visible:ring-[2.5px] tablet-portrait:-@:focus-visible:ring-[2.5px]',
      '@tablet-portrait/surface-container:ring-offset-[1.5px] tablet-portrait:-@:ring-offset-[1.5px]',
      'dark:ring-offset-grey-900 ring-offset-white',
      'ring-grape-500 dark:ring-canary-500',

      _vm.color === 'green' && [
        'hfocus-visible:bg-park-200',
        'hactive:bg-park-200',
        'pulse-bg-from-park-0 pulse-bg-to-park-200',
      ],
      _vm.color === 'orange' && [
        'hfocus-visible:bg-tangerine-100',
        'hactive:bg-tangerine-100',
        'pulse-bg-from-tangerine-0 pulse-bg-to-tangerine-200',
      ],
      _vm.color === 'pink' && [
        'hfocus-visible:bg-padlet-pink-100',
        'hactive:bg-padlet-pink-100',
        'pulse-bg-from-padlet-pink-0 pulse-bg-to-padlet-pink-200',
      ],
      _vm.color === 'blue' && [
        'hfocus-visible:bg-oceanic-100',
        'hactive:bg-oceanic-100',
        'pulse-bg-from-oceanic-0 pulse-bg-to-oceanic-200',
      ],
      _vm.color === 'purple' && [
        'hfocus-visible:bg-grape-100',
        'hactive:bg-grape-100',
        'pulse-bg-from-grape-0 pulse-bg-to-grape-200',
      ],
      _vm.color === 'teal' && [
        'hfocus-visible:bg-teal-100',
        'hactive:bg-teal-100',
        'pulse-bg-from-teal-0 pulse-bg-to-teal-200',
      ],
    ],
  ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.iconName)?_c(_setup.OzIcon,{class:['shrink-0', _setup.iconColorClasses],style:(_setup.iconStrokeWidthStyle),attrs:{"size":24,"name":_vm.iconName}}):(_vm.avatarUrl)?_c(_setup.OzAvatar,{class:['shrink-0 rounded-full', _setup.iconColorClasses],attrs:{"height":24,"width":24,"src":_vm.avatarUrl,"alt-text-name":_vm.avatarAltText}}):_vm._e(),_vm._v(" "),_c('span',{class:[
      'mx-3 text-body-posts @tablet-portrait/surface-container:text-body-small tablet-portrait:-@:text-body-small text-start truncate grow',
      _vm.subtext && 'max-w-[60%] shrink-0',
    ]},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.subtext)?_c('span',{staticClass:"ms-auto me-4 text-body-small text-dark-text-200 dark:text-light-text-200 truncate"},[_vm._v(_vm._s(_vm.subtext))]):_vm._e(),_vm._v(" "),(_vm.xNewBadge)?_c(_setup.OzBadge,{class:[
      'text-light-text-100',
      'bg-park-500 dark:bg-park-800',
      'me-4 @tablet-portrait/surface-container:me-2.5 tablet-portrait:-@:me-2.5',
      'px-1.5 h-5',
      'rounded-md',
    ],attrs:{"text":_vm.__('New'),"color-scheme":_setup.OzBadgeColorScheme.Bare}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }